/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type VerticalType = "%future added value" | "art" | "fashion" | "furniture" | "jewelry" | "%future added value";
export type SbSharedNullSearchRelatedItems_itemSearch = {
    readonly relatedSearchResults: {
        readonly edges: ReadonlyArray<{
            readonly node: {
                readonly item: {
                    readonly title: string | null;
                    readonly serviceId: string | null;
                    readonly browseUrl: string | null;
                    readonly categoryCode: string | null;
                    readonly vertical: VerticalType | null;
                    readonly seller: {
                        readonly serviceId: string | null;
                    } | null;
                    readonly contemporaryTrackingString: string;
                    readonly shipmentQuotes: ReadonlyArray<{
                        readonly totalAmount: {
                            readonly amount: number | null;
                        } | null;
                        readonly serviceMethod: {
                            readonly region: {
                                readonly regionName: string | null;
                            } | null;
                        } | null;
                    } | null> | null;
                    readonly " $fragmentRefs": FragmentRefs<"SharedItemTile_item">;
                } | null;
            } | null;
        } | null> | null;
    } | null;
    readonly " $fragmentRefs": FragmentRefs<"useMeasurementUnit_itemSearch" | "SbSharedSearchSuggestions_itemSearch" | "SbSharedNullSearchRelatedItemsFollow_itemSearch">;
    readonly " $refType": "SbSharedNullSearchRelatedItems_itemSearch";
};
export type SbSharedNullSearchRelatedItems_itemSearch$data = SbSharedNullSearchRelatedItems_itemSearch;
export type SbSharedNullSearchRelatedItems_itemSearch$key = {
    readonly " $data"?: SbSharedNullSearchRelatedItems_itemSearch$data;
    readonly " $fragmentRefs": FragmentRefs<"SbSharedNullSearchRelatedItems_itemSearch">;
};



const node: ReaderFragment = (function(){
var v0 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "serviceId",
  "args": null,
  "storageKey": null
};
return {
  "kind": "Fragment",
  "name": "SbSharedNullSearchRelatedItems_itemSearch",
  "type": "ItemSearchQueryConnection",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "relatedSearchResults",
      "storageKey": null,
      "args": null,
      "concreteType": "ItemSearchResultConnection",
      "plural": false,
      "selections": [
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "edges",
          "storageKey": null,
          "args": null,
          "concreteType": "ItemSearchResultEdge",
          "plural": true,
          "selections": [
            {
              "kind": "LinkedField",
              "alias": null,
              "name": "node",
              "storageKey": null,
              "args": null,
              "concreteType": "ItemSearchResult",
              "plural": false,
              "selections": [
                {
                  "kind": "LinkedField",
                  "alias": null,
                  "name": "item",
                  "storageKey": null,
                  "args": null,
                  "concreteType": "Item",
                  "plural": false,
                  "selections": [
                    {
                      "kind": "ScalarField",
                      "alias": null,
                      "name": "title",
                      "args": null,
                      "storageKey": null
                    },
                    (v0/*: any*/),
                    {
                      "kind": "ScalarField",
                      "alias": null,
                      "name": "browseUrl",
                      "args": null,
                      "storageKey": null
                    },
                    {
                      "kind": "ScalarField",
                      "alias": null,
                      "name": "categoryCode",
                      "args": null,
                      "storageKey": null
                    },
                    {
                      "kind": "ScalarField",
                      "alias": null,
                      "name": "vertical",
                      "args": null,
                      "storageKey": null
                    },
                    {
                      "kind": "LinkedField",
                      "alias": null,
                      "name": "seller",
                      "storageKey": null,
                      "args": null,
                      "concreteType": "Seller",
                      "plural": false,
                      "selections": [
                        (v0/*: any*/)
                      ]
                    },
                    {
                      "kind": "ScalarField",
                      "alias": null,
                      "name": "contemporaryTrackingString",
                      "args": null,
                      "storageKey": null
                    },
                    {
                      "kind": "LinkedField",
                      "alias": null,
                      "name": "shipmentQuotes",
                      "storageKey": null,
                      "args": null,
                      "concreteType": "ShipmentQuote",
                      "plural": true,
                      "selections": [
                        {
                          "kind": "LinkedField",
                          "alias": null,
                          "name": "totalAmount",
                          "storageKey": null,
                          "args": null,
                          "concreteType": "FinancialAmount",
                          "plural": false,
                          "selections": [
                            {
                              "kind": "ScalarField",
                              "alias": null,
                              "name": "amount",
                              "args": null,
                              "storageKey": null
                            }
                          ]
                        },
                        {
                          "kind": "LinkedField",
                          "alias": null,
                          "name": "serviceMethod",
                          "storageKey": null,
                          "args": null,
                          "concreteType": "ShipmentServiceMethod",
                          "plural": false,
                          "selections": [
                            {
                              "kind": "LinkedField",
                              "alias": null,
                              "name": "region",
                              "storageKey": null,
                              "args": null,
                              "concreteType": "Region",
                              "plural": false,
                              "selections": [
                                {
                                  "kind": "ScalarField",
                                  "alias": null,
                                  "name": "regionName",
                                  "args": null,
                                  "storageKey": null
                                }
                              ]
                            }
                          ]
                        }
                      ]
                    },
                    {
                      "kind": "FragmentSpread",
                      "name": "SharedItemTile_item",
                      "args": null
                    }
                  ]
                }
              ]
            }
          ]
        }
      ]
    },
    {
      "kind": "InlineDataFragmentSpread",
      "name": "useMeasurementUnit_itemSearch",
      "selections": [
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "appliedFilters",
          "storageKey": null,
          "args": null,
          "concreteType": "SearchBrowseParsedParam",
          "plural": true,
          "selections": [
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "name",
              "args": null,
              "storageKey": null
            },
            {
              "kind": "LinkedField",
              "alias": null,
              "name": "values",
              "storageKey": null,
              "args": null,
              "concreteType": "SearchBrowseParsedParamValue",
              "plural": true,
              "selections": [
                {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "urlLabel",
                  "args": null,
                  "storageKey": null
                }
              ]
            }
          ]
        }
      ]
    },
    {
      "kind": "FragmentSpread",
      "name": "SbSharedSearchSuggestions_itemSearch",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "SbSharedNullSearchRelatedItemsFollow_itemSearch",
      "args": null
    }
  ]
};
})();
(node as any).hash = '053d1aa5a4da7cff77dbe5906531213d';
export default node;
